module.exports = __webpack_public_path__ + "img/Shield Cracked.92411db5.png";